import { render } from "./menu_wo_inertia.vue?vue&type=template&id=1962ae16&scoped=true"
import script from "./menu_wo_inertia.vue?vue&type=script&lang=js"
export * from "./menu_wo_inertia.vue?vue&type=script&lang=js"

import "./menu_wo_inertia.vue?vue&type=style&index=0&id=1962ae16&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/translation_system/translation_system/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1962ae16"]])

export default __exports__